var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page-sticky',{attrs:{"position":"bottom-right","offset":[18, 18]}},[_c('q-btn',{attrs:{"fab":"","icon":_vm.$props.icon || 'add',"color":_vm.$props.color || 'accent'},on:{"click":_vm.$props.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }